/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface AcceptTradeRequest {
    scheduleId: string;
    tradeId: string;
    participantId: string;
    sessionId?: string;
}

export interface CancelTradeRequest {
    scheduleId: string;
    tradeId: string;
    participantId: string;
    sessionId?: string;
}

export interface GetTradeRequest {
    scheduleId: string;
    tradeId: string;
    sessionId?: string;
}

export interface ListTradesForScheduleRequest {
    scheduleId: string;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface RejectTradeRequest {
    scheduleId: string;
    tradeId: string;
    participantId: string;
    reason?: string;
    sessionId?: string;
}

export interface RequestTradeRequest {
    scheduleId: string;
    blockId: string;
    fromParticipantId: string;
    toParticipantId: string;
    sessionId?: string;
}

/**
 * ShiftTradingApi - interface
 * 
 * @export
 * @interface ShiftTradingApiInterface
 */
export interface ShiftTradingApiInterface {
    /**
     * Accepts a pending shift trade (recipient only)
     * @summary Accept trade
     * @param {string} scheduleId Schedule ID
     * @param {string} tradeId Trade ID
     * @param {string} participantId Participant ID of the acceptor (must be to_participant)
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTradingApiInterface
     */
    acceptTradeRaw(requestParameters: AcceptTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Accepts a pending shift trade (recipient only)
     * Accept trade
     */
    acceptTrade(requestParameters: AcceptTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Cancels a pending shift trade (requester or from-participant)
     * @summary Cancel trade
     * @param {string} scheduleId Schedule ID
     * @param {string} tradeId Trade ID
     * @param {string} participantId Participant ID of the canceller (requester or from-participant)
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTradingApiInterface
     */
    cancelTradeRaw(requestParameters: CancelTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Cancels a pending shift trade (requester or from-participant)
     * Cancel trade
     */
    cancelTrade(requestParameters: CancelTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Gets a shift trade by ID
     * @summary Get trade
     * @param {string} scheduleId Schedule ID
     * @param {string} tradeId Trade ID
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTradingApiInterface
     */
    getTradeRaw(requestParameters: GetTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Gets a shift trade by ID
     * Get trade
     */
    getTrade(requestParameters: GetTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all shift trades for a schedule
     * @summary List trades for schedule
     * @param {string} scheduleId Schedule ID
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTradingApiInterface
     */
    listTradesForScheduleRaw(requestParameters: ListTradesForScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all shift trades for a schedule
     * List trades for schedule
     */
    listTradesForSchedule(requestParameters: ListTradesForScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Rejects a pending shift trade (recipient only)
     * @summary Reject trade
     * @param {string} scheduleId Schedule ID
     * @param {string} tradeId Trade ID
     * @param {string} participantId Participant ID of the rejector (must be to_participant)
     * @param {string} [reason] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTradingApiInterface
     */
    rejectTradeRaw(requestParameters: RejectTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Rejects a pending shift trade (recipient only)
     * Reject trade
     */
    rejectTrade(requestParameters: RejectTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Request to trade a shift to another participant
     * @summary Request shift trade
     * @param {string} scheduleId Schedule ID
     * @param {string} blockId Block ID
     * @param {string} fromParticipantId From participant ID (current assignee)
     * @param {string} toParticipantId To participant ID (recipient)
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTradingApiInterface
     */
    requestTradeRaw(requestParameters: RequestTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Request to trade a shift to another participant
     * Request shift trade
     */
    requestTrade(requestParameters: RequestTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class ShiftTradingApi extends runtime.BaseAPI implements ShiftTradingApiInterface {

    /**
     * Accepts a pending shift trade (recipient only)
     * Accept trade
     */
    async acceptTradeRaw(requestParameters: AcceptTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling acceptTrade().'
            );
        }

        if (requestParameters['tradeId'] == null) {
            throw new runtime.RequiredError(
                'tradeId',
                'Required parameter "tradeId" was null or undefined when calling acceptTrade().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling acceptTrade().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['participantId'] != null) {
            queryParameters['participantId'] = requestParameters['participantId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/trades/{tradeId}/accept`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"tradeId"}}`, encodeURIComponent(String(requestParameters['tradeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Accepts a pending shift trade (recipient only)
     * Accept trade
     */
    async acceptTrade(requestParameters: AcceptTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.acceptTradeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancels a pending shift trade (requester or from-participant)
     * Cancel trade
     */
    async cancelTradeRaw(requestParameters: CancelTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling cancelTrade().'
            );
        }

        if (requestParameters['tradeId'] == null) {
            throw new runtime.RequiredError(
                'tradeId',
                'Required parameter "tradeId" was null or undefined when calling cancelTrade().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling cancelTrade().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['participantId'] != null) {
            queryParameters['participantId'] = requestParameters['participantId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/trades/{tradeId}/cancel`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"tradeId"}}`, encodeURIComponent(String(requestParameters['tradeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Cancels a pending shift trade (requester or from-participant)
     * Cancel trade
     */
    async cancelTrade(requestParameters: CancelTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cancelTradeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a shift trade by ID
     * Get trade
     */
    async getTradeRaw(requestParameters: GetTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling getTrade().'
            );
        }

        if (requestParameters['tradeId'] == null) {
            throw new runtime.RequiredError(
                'tradeId',
                'Required parameter "tradeId" was null or undefined when calling getTrade().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/trades/{tradeId}`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"tradeId"}}`, encodeURIComponent(String(requestParameters['tradeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Gets a shift trade by ID
     * Get trade
     */
    async getTrade(requestParameters: GetTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTradeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all shift trades for a schedule
     * List trades for schedule
     */
    async listTradesForScheduleRaw(requestParameters: ListTradesForScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling listTradesForSchedule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/trades`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all shift trades for a schedule
     * List trades for schedule
     */
    async listTradesForSchedule(requestParameters: ListTradesForScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listTradesForScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rejects a pending shift trade (recipient only)
     * Reject trade
     */
    async rejectTradeRaw(requestParameters: RejectTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling rejectTrade().'
            );
        }

        if (requestParameters['tradeId'] == null) {
            throw new runtime.RequiredError(
                'tradeId',
                'Required parameter "tradeId" was null or undefined when calling rejectTrade().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling rejectTrade().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['participantId'] != null) {
            queryParameters['participantId'] = requestParameters['participantId'];
        }

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/trades/{tradeId}/reject`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"tradeId"}}`, encodeURIComponent(String(requestParameters['tradeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Rejects a pending shift trade (recipient only)
     * Reject trade
     */
    async rejectTrade(requestParameters: RejectTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.rejectTradeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request to trade a shift to another participant
     * Request shift trade
     */
    async requestTradeRaw(requestParameters: RequestTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling requestTrade().'
            );
        }

        if (requestParameters['blockId'] == null) {
            throw new runtime.RequiredError(
                'blockId',
                'Required parameter "blockId" was null or undefined when calling requestTrade().'
            );
        }

        if (requestParameters['fromParticipantId'] == null) {
            throw new runtime.RequiredError(
                'fromParticipantId',
                'Required parameter "fromParticipantId" was null or undefined when calling requestTrade().'
            );
        }

        if (requestParameters['toParticipantId'] == null) {
            throw new runtime.RequiredError(
                'toParticipantId',
                'Required parameter "toParticipantId" was null or undefined when calling requestTrade().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockId'] != null) {
            queryParameters['blockId'] = requestParameters['blockId'];
        }

        if (requestParameters['fromParticipantId'] != null) {
            queryParameters['fromParticipantId'] = requestParameters['fromParticipantId'];
        }

        if (requestParameters['toParticipantId'] != null) {
            queryParameters['toParticipantId'] = requestParameters['toParticipantId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/trades/request`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Request to trade a shift to another participant
     * Request shift trade
     */
    async requestTrade(requestParameters: RequestTradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.requestTradeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
